
  export default {
    props: {
      addressKey: { type: String, default: null },
      field: { type: String, required: true },
      fieldType: { type: String, default: 'text' },
      i18nModel: { type: String, default: null },
      inlineLabel: { type: String, default: null },
      inputAttrs: { type: Object, default () { return {}; } },
      constraints: { type: Object, default () { return {}; } },
      modelName: { type: String, required: true },
      radioOptions: { type: Array, default: null },
      rangeMoney: { type: Boolean, required: false },
      required: { type: Boolean, default: false },
      stopFormSubmit: { type: Boolean, default: false }
    },
    data () {
      return {
        currentYear: parseInt(new Date().getFullYear().toString().slice(2), 10),
        initialValue: null,
        internationalNumber: false,
        timer: null,
        prevValue: null
      };
    },
    computed: {
      value () {
        if (this.subField) {
          return this.$formGet(this.modelName, this.subField)[this.field];
        } else {
          return this.$formGet(this.modelName, this.field);
        }
      },
      attribute: {
        get () {
          let v;
          if (this.subField) {
            v = this.$formGet(this.modelName, this.subField, this.addressKey)[this.field];
          } else {
            v = this.$formGet(this.modelName, this.field, this.addressKey);
          }
          return v;
        },
        set (value) {
          this.prevValue = value;
          if (!this.timer) {
            this.inputActivities(value);

            this.prevValue = null;

            this.timer = setInterval(() => {
              if (!this.prevValue) {
                this.timer = clearInterval(this.timer);
              } else {
                this.inputActivities(this.prevValue);

                this.prevValue = null;
              }
            }, 100);
          }
        }
      },
      inputMask () {
        if (this.inputAttrs['disable-mask']) {
          return null;
        }
        if (this.fieldType === 'tel') {
          if (this.inputAttrs['data-international-number']) {
            return '###############';
          }
          if (this.inputAttrs['data-home-number']) {
            return null;
          }
          return '(###) ###-####';
        }
        if (this.inputAttrs['data-car-registration']) {
          let value = (this.attribute || '').replace(/-/g, '');
          let str = '##';
          if (value.match(/^\d\d/)) {
            const year = value.slice(0, 2);
            if (year > this.currentYear && year < 87) {
              return str;
            }
            if (year > 12 && year <= this.currentYear) {
              str += '#';
            }
          }
          if (value.match(/^\d\d\d/) && !value.match(/^\d\d[1-2]/)) {
            return str;
          }
          str += '-A';
          if (value.match(/^\d+[a-zA-Z][a-zA-Z]/)) {
            str += 'A';
          }
          if (value.match(/^\d+[a-zA-Z]([a-zA-Z]|\d)/)) {
            str += '-#?######';
          }
          return str;
        }
        return null;
      },
      inputPattern () {
        if (!this.inputMask) {
          return null;
        }
        if (this.fieldType === 'tel') {
          if (this.inputAttrs['data-international-number'] || this.inputAttrs['data-home-number']) {
            return null;
          } else {
            return '\\(08\\d\\) \\d{3}-\\d{4}';
          }
        }
        if (this.inputAttrs['data-car-registration']) {
          return '\\d{2,3}-\\w{1,2}-\\d{1,7}';
        }
        return null;
      },
      subField () {
        return this.inputAttrs['data-sub-field'];
      }
    },
    watch: {
      'inputAttrs.max' (newValue) {
        if (this.fieldType === 'range') {
          this.sliderProgress();

          if (this.value > newValue) {
            this.attribute = newValue;
          }
        }
      },
      'inputAttrs.min' () {
        if (this.fieldType === 'range') {
          this.sliderProgress();
        }
      },
      value (newValue) {
        if (newValue === undefined) return;

        if (this.fieldType === 'tel') {
          if (this.initialValue) {
            if (!this.inputAttrs['data-international-number'] || !this.inputAttrs['data-home-number']) {
              if (newValue.length === 10 && this.initialValue.length >= 9) {
                this.attribute = this.initialValue;
              }
            }
          }
        }
        if (this.fieldType === 'range') {
          this.sliderProgress();
          if (newValue > this.inputAttrs.max) {
            this.attribute = this.inputAttrs.max;
          }
        }
      }
    },
    beforeDestroy () {
      if (this.inputAttrs['data-do-reset']) {
        this.attribute = this.initialValue;
      }
    },
    mounted () {
      this.initialValue = this.attribute;
      if (this.fieldType === 'range') {
        this.sliderProgress();
      }
    },
    methods: {
      rangeConstraint (value) {
        if (this.inputAttrs.type === 'ber') {
          return value === 'min' ? "Don't know" : 'A1';
        } else if (this.inputAttrs.type === 'years-driving') {
          return value === 'min' ? 'Less than 1 year' : '10 or more';
        } else if (this.inputAttrs.type === '€') {
          return this.$n(this.inputAttrs[value], 'currencyRound');
        } else if (this.inputAttrs.type === 'number') {
          return this.$n(this.inputAttrs[value]);
        } else {
          return this.$tc(this.inputAttrs.type, this.inputAttrs[value]);
        }
      },
      setForm (h) {
        this.$formSet(this.modelName, { ...h, ...{ key: this.addressKey } });
      },
      sliderProgress () {
        if (!this.$refs[this.field]) {
          return;
        }
        this.$refs[this.field].style.backgroundSize =
          ((this.value - this.inputAttrs.min) * 100) /
          (this.inputAttrs.max - this.inputAttrs.min) +
          '% 100%';
      },
      inputActivities (value) {
        const h = {};
        if (this.subField) {
          const hh = {};
          hh[this.field] = value;
          h[this.subField] = { ...this.$formGet(this.modelName, this.subField), ...hh };
        } else {
          if (this.fieldType === 'range') {
            value = parseInt(value);
          }
          h[this.field] = value;
        }
        this.setForm(h);
      }
    }
  };
